module.exports = __webpack_public_path__ + "img/program1-s.2fde9916.png";